import React, { Suspense, lazy } from 'react';
import { LinearProgress } from '@mui/material';

const ReactEcharts = lazy(() => import('echarts-for-react'));

/**
 * Helper to lazy-load echarts in order to facilitate code splitting
 *
 * This should be the ONLY import of echarts-for-react so that webpack can put it + deps
 * into a separate JS bundle and we can avoid parsing it at first page load
 */
const Echarts = (props) => (
  <Suspense fallback={<LinearProgress color="secondary" />}>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <ReactEcharts lazyUpdate {...props} />
  </Suspense>
);

export default Echarts;
